import React, {Component} from 'react';
import {HashRouter, Route, Switch} from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import './App.scss';

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;


// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));
const PublicLayout = React.lazy(() => import('./containers/PublicLayout'));

// Pages
const Login = React.lazy(() => import('./views/CapstonePublic/Login'));
const Page404 = React.lazy(() => import('./views/CapstonePublic/Page404'));
const Page500 = React.lazy(() => import('./views/CapstonePublic/Page500'));


class App extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <HashRouter>
          <React.Suspense fallback={loading()}>
            <Switch>


              <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />


              <Route path="/admin" name="Dashboard" render={props => <DefaultLayout {...props}/>} />


              <Route path="/" name="Home" render={props => <PublicLayout {...props}/>} />


            </Switch>
          </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
